import React from 'react'

export default function TechnologiesCard() {
    return (
        <section className=' px-0 px-md-5 pb-0 padding-section-large TechStackCard'>
            <div className='p-5 rounded-24 bg-grey'>
                <h4 className='max-width-large mx-auto text-center pb-3'>We’ve earned a reputation for providing <strong>highly skilled, reliable, and collaborative talent</strong> across key technology domains, including:</h4>
                <div className='d-flex gap-4 pt-3 mobile-wrap'>
                    <div className='col d-flex flex-column text-center shadow-sm gap-2 border rounded p-3 bg-white'>
                        <div><i class="fi fi-tr-display-code display-4" style={{ "color": "#1D69BC" }}></i></div>
                        <strong className="black clearfix pb-2">Backend Development</strong>
                        <ul class="list-unstyled list-inline">
                            <li class="list-inline-item py-1"> Java</li>
                            <li class="list-inline-item py-1"> .NET</li>
                            <li class="list-inline-item py-1"> Ruby on Rails</li>
                            <li class="list-inline-item py-1"> Node.js</li>
                            <li class="list-inline-item py-1"> Laravel</li>
                            <li class="list-inline-item py-1"> Django</li>
                        </ul>
                    </div>
                    <div className='col d-flex flex-column text-center shadow-sm gap-2 border rounded p-3 bg-white'>
                        <div><i class="fi fi-tr-mobile-notch display-4" style={{ "color": "#1D69BC" }}></i></div>
                        <strong className="black clearfix pb-2">Frontend & Mobile Development</strong>
                        <ul class="list-unstyled list-inline">
                            <li class="list-inline-item py-1"> React.js</li>
                            <li class="list-inline-item py-1"> Flutter</li>
                            <li class="list-inline-item py-1"> Angular</li>
                            <li class="list-inline-item py-1"> Kotlin</li>
                            <li class="list-inline-item py-1"> Swift</li>
                            <li class="list-inline-item py-1"> React Native</li>
                            <li class="list-inline-item py-1"> Ionic</li>
                        </ul>
                    </div>
                    <div className='col d-flex flex-column text-center shadow-sm gap-2 border rounded p-3 bg-white'>
                        <div><i class="fi fi-tr-employees display-4" style={{ "color": "#1D69BC" }}></i></div>
                        <strong className="black clearfix pb-2">Delivery & Product Management</strong>
                        <ul class="list-unstyled list-inline">
                            <li class="list-inline-item py-1"> Product Managers</li>
                            <li class="list-inline-item py-1"> Program Managers</li>
                            <li class="list-inline-item py-1"> Account Managers</li>
                            <li class="list-inline-item py-1"> Scrum Masters</li>
                        </ul>
                    </div>
                    <div className='col d-flex flex-column text-center shadow-sm gap-2 border rounded p-3 bg-white'>
                        <div><i class="fi fi-tr-system-cloud display-4" style={{ "color": "#1D69BC" }}></i></div>
                        <strong className="black clearfix pb-2">Cloud & DevOps</strong>
                        <ul class="list-unstyled list-inline">
                            <li class="list-inline-item py-1"> AWS</li>
                            <li class="list-inline-item py-1"> Azure</li>
                            <li class="list-inline-item py-1"> Docker</li>
                            <li class="list-inline-item py-1"> Kubernetes</li>
                        </ul>
                    </div>
                    <div className='col d-flex flex-column text-center shadow-sm gap-2 border rounded p-3 bg-white'>
                        <div><i class="fi fi-ts-discover display-4" style={{ "color": "#1D69BC" }}></i></div>

                        <strong className="black clearfix pb-2">Quality Assurance</strong>
                        <ul class="list-unstyled list-inline">
                            <li class="list-inline-item py-1"> Selenium</li>
                            <li class="list-inline-item py-1"> Playwright</li>
                            <li class="list-inline-item py-1"> JMeter</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section >
    )
}
